import { dispatch, runAction } from '@pressreader/appstore';
import { configLoadDone, configLoadFailed, loadConfigAction, setGetConfigService } from '@pressreader/config';
import { error } from '@pressreader/logger';
import {
    loadResourcesAction,
    resourcesLoadDone,
    resourcesLoadFailed,
    setGetAllTemplatesService,
    setGetResourcesService,
} from '@pressreader/resources';
import { svcAuth } from '@pressreader/services';

import { getConfig } from './api/get-config';
import { getAllTemplates, getResources } from './api/get-resources';
import { initCookieBot } from './cookiebot';
import { initHeartBeatSystem } from './heartbeat';
import { coreModuleLoadDone } from './store';
import { checkPervasiveUrlQueryParam, resolveFaceliftEnabled, resolveTargetPlatform } from './utils';

let initialized = false;

export async function init() {
    if (initialized) {
        return;
    }

    await svcAuth.initAuthTickets();

    svcAuth.bind('tokenUpdated', () => {
        dispatch(loadConfigAction());
    });

    initialized = true;

    setGetConfigService(getConfig);
    setGetResourcesService(getResources);
    setGetAllTemplatesService(getAllTemplates);

    try {
        await runAction(loadConfigAction(), configLoadDone, configLoadFailed);
    } catch (e) {
        error('Cannot load config.', e);
        return;
    }

    try {
        await runAction(loadResourcesAction(), resourcesLoadDone, resourcesLoadFailed);
    } catch (e) {
        error('Cannot load resources.', e);
        return;
    }

    checkPervasiveUrlQueryParam();
    const targetPlatform = resolveTargetPlatform();
    const faceliftEnabled = resolveFaceliftEnabled();

    initCookieBot();
    dispatch(coreModuleLoadDone({ targetPlatform, faceliftEnabled }));

    initHeartBeatSystem();
}

export { getConfig } from './api/get-config';
export { getResources } from './api/get-resources';
